import CoursesBlock, { CoursesBlockProps } from './CoursesBlock';
import withPresenter from './CoursesBlock.presenter';
import withInteractor from './CoursesBlock.interactor';

export type { CoursesBlockProps };
export default withInteractor(withPresenter(CoursesBlock));
